import React from "react";
import { Switch, Route } from "react-router-dom";
import Plans from "./Plans";
import Payment from "./Payment";
import Home from "./Home";
import Proceed from "./Proceed";
import Account from "./Account";
import Withdraw from "./Withdraw";
import Withdrawals from "./Withdrawals";
import Deposits from "./Deposits";
import Fund from "./fund";

const Dashboard = ({ match: { path } }) => {
  return (
    <Switch>
      <Route exact path={path}>
        <Home />
      </Route>
      <Route path={`${path}/plans`}>
        <Plans />
      </Route>
      <Route path={`${path}/proceed`}>
        <Proceed />
      </Route>
      <Route path={`${path}/fund`}>
        <Fund />
      </Route>
      <Route path={`${path}/payment/:id`}>
        <Payment />
      </Route>
      <Route path={`${path}/account`}>
        <Account />
      </Route>
      <Route path={`${path}/withdraw`}>
        <Withdraw />
      </Route>
      <Route path={`${path}/withdrawals`}>
        <Withdrawals />
      </Route>
      <Route path={`${path}/deposits`}>
        <Deposits />
      </Route>
    </Switch>
  );
};

export default Dashboard;
